var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWheelchairAccessories(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.33,34.13h-2.1l1.05-12.09c.11-1.23-.31-2.47-1.15-3.38-.84-.91-2.03-1.44-3.27-1.44h-7.16V8.82c0-.98-.45-1.89-1.22-2.48-.78-.6-1.76-.8-2.71-.55l-7.59,2.01c-.8,.21-1.28,1.03-1.07,1.83,.21,.8,1.03,1.28,1.83,1.07l7.59-2.01s.06-.02,.12,.02c.05,.04,.05,.09,.05,.11v8.4h-7.16c-1.24,0-2.43,.52-3.27,1.44-.84,.91-1.26,2.15-1.15,3.38l1.05,12.09h-2.1c-.83,0-1.5,.67-1.5,1.5v2.66h-4.54c-.83,0-1.5,.67-1.5,1.5v11.42c0,.83,.67,1.5,1.5,1.5h4.63c.41,2.36,2.46,4.16,4.93,4.16h21.24c2.76,0,5.01-2.25,5.01-5.01v-16.23c0-.83-.67-1.5-1.5-1.5Zm-23.85-13.45c.28-.3,.65-.47,1.06-.47h17.32c.41,0,.78,.17,1.06,.47,.28,.3,.41,.69,.37,1.09l-.27,3.16H23.38l-.27-3.16c-.04-.41,.1-.79,.37-1.09Zm.16,7.26h19.11l-.54,6.19H24.17l-.54-6.19Zm-9.12,13.35h3.04v8.42h-3.04v-8.42Zm31.31,10.56c0,1.11-.9,2.01-2.01,2.01H22.57c-1.11,0-2.01-.9-2.01-2.01v-14.73h25.27v14.73Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelchairAccessories);
export default __webpack_public_path__ + "static/media/wheelchair_accessories.f0f30653.svg";
export { ForwardRef as ReactComponent };